<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" [ngClass]="backgroundTitleCls">
    <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId" class="ps-1">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-none d-lg-flex me-auto">
      <c-nav-item *ngFor="let menuItem of headerNavItems">
        <a cNavLink [routerLink]="menuItem.url" routerLinkActive="active">
          {{ menuItem.name }}
        </a>
      </c-nav-item>
    </c-header-nav>

    <c-header-nav class="d-none d-lg-flex">
      <c-nav-item *ngIf="updater.isNewVersionAvailable">
        <a class="text-success" routerLink="./" cNavLink title="Há uma atualização disponível!" (click)="applyUpdate()">
          <svg cIcon name="cilCloudDownload" size="lg"></svg>
        </a>
      </c-nav-item>

      <!-- Tarefas -->
      <app-task-status-notification></app-task-status-notification>

      <!-- <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilList" size="lg"></svg>
        </a>
      </c-nav-item>
      <c-nav-item>
        <a routerLink="./" cNavLink>
          <svg cIcon name="cilEnvelopeOpen" size="lg"></svg>
        </a>
      </c-nav-item> -->
    </c-header-nav>

    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>

  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    <c-breadcrumb-router class="ms-2"></c-breadcrumb-router>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button cButton color="" [caret]="false" cDropdownToggle class="py-0">
      <c-avatar cTextColor="primary" shape="rounded-1" size="md" src="assets/img/avatars/photo-user.png"
        status="success">
      </c-avatar>
      <span class="m-2 d-none d-sm-none d-md-none d-lg-inline">{{ userName }}</span>
    </button>
    <ul cDropdownMenu class="pt-0 ">
      <li>
        <h6 cDropdownHeader class="bg-light fw-semibold py-2">Configurações</h6>
      </li>
      <li></li>
      <li>
        <a routerLink="./" cDropdownItem>
          <svg cIcon class="me-2" name="cilUser"></svg>
          Perfil
        </a>
      </li>
      <li>
        <a routerLink="/tasks" cDropdownItem>
          <svg cIcon class="me-2" name="cilBell"></svg>
          Tarefas do Servidor
        </a>
      </li>
      <li>
        <a routerLink="/configuracao" cDropdownItem>
          <svg cIcon class="me-2" name="cilSettings"></svg>
          Configurações
        </a>
      </li>
      <li *ngFor="let action of dropdownMenuActions">
        <a class="click" (click)="action.action()" cDropdownItem>
          <svg cIcon class="me-2" name="{{ action.icon }}"></svg>
          {{ action.label }}
        </a>
      </li>
      <li *ngIf="sync">
        <a class="click" (click)="sync()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLoopCircular"></svg>
          Sincronizar
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a class="click" (click)="logout()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg>
          Sair
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a class="click text-center p-0" style="font-size: 0.775rem;" (click)="checkForUpdate()" cDropdownItem>
          <small>
            <!-- <svg cIcon class="me-2" name="cilLan"></svg> -->
            Versão: {{ appVersion }}
          </small>
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>
